<template>
  <div class="conformationWrap">
    <h4 class="subTitle">프로젝트 형태</h4>
    <category-list-contactus/>
  </div>
</template>

<script>


    import CategoryListContactus from "./CategoryList";

    export default {
        name: "conformation" ,
        components : {
          CategoryListContactus

        }
    }
</script>

<style scoped lang="scss">
  @import "@/styles/ContactUs.scss";
</style>



// WEBPACK FOOTER //
// src/components/menu/ContactUs/Conformation.vue